import { useState, FormEvent } from 'react';

const CONTACT_INFO = [
  { icon: 'ri-phone-line', label: 'Telefone / WhatsApp', value: '(11) 4345-3116' },
  { icon: 'ri-mail-line', label: 'E-mail', value: 'comercial@mrcti.com.br' },
  { icon: 'ri-map-pin-line', label: 'Localização', value: 'São Bernardo do Campo, SP - Brasil' },
  { icon: 'ri-time-line', label: 'Horário', value: 'Seg-Sex: 8h às 18h' },
];

export default function ContactSection() {
  const [status, setStatus] = useState<'idle' | 'sending' | 'success' | 'error'>('idle');
  const [charCount, setCharCount] = useState(0);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const form = e.currentTarget;
    const message = (form.elements.namedItem('message') as HTMLTextAreaElement)?.value || '';
    if (message.length > 500) return;

    setStatus('sending');

    const formData = new URLSearchParams();
    const elements = form.elements;
    for (let i = 0; i < elements.length; i++) {
      const el = elements[i] as HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement;
      if (el.name) {
        if (el.tagName === 'SELECT') {
          formData.append(el.name, (el as HTMLSelectElement).value);
        } else {
          formData.append(el.name, el.value);
        }
      }
    }

    try {
      const res = await fetch('https://readdy.ai/api/form/d73kq4j41deorl02ees0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formData.toString(),
      });
      if (res.ok) {
        setStatus('success');
        form.reset();
        setCharCount(0);
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  };

  return (
    <section id="contact" className="bg-brand-bg py-24">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="text-neon-green text-xs font-bold tracking-widest uppercase mb-3 block">
            Entre em Contato
          </span>
          <h2 className="text-3xl md:text-4xl font-extrabold text-white mb-4">
            Vamos falar sobre o seu projeto?
          </h2>
          <p className="text-gray-400 max-w-xl mx-auto text-sm">
            Preencha o formulário e um especialista entrará em contato em até 24 horas.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Contact Info */}
          <div>
            <h3 className="text-white font-bold text-lg mb-6">Informações de contato</h3>
            <div className="space-y-5 mb-10">
              {CONTACT_INFO.map((info) => (
                <div key={info.label} className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-neon-green/10 rounded-lg flex-shrink-0">
                    <i className={`${info.icon} text-neon-green`} />
                  </div>
                  <div>
                    <p className="text-gray-500 text-xs">{info.label}</p>
                    <p className="text-white text-sm font-medium mt-0.5">{info.value}</p>
                  </div>
                </div>
              ))}
            </div>

            {/* Social */}
            <div>
              <p className="text-gray-500 text-xs mb-3">Siga-nos nas redes sociais</p>
              <div className="flex gap-3">
                {[
                  { icon: 'ri-instagram-line', label: 'Instagram' },
                  { icon: 'ri-linkedin-box-line', label: 'LinkedIn' },
                  { icon: 'ri-whatsapp-line', label: 'WhatsApp' },
                  { icon: 'ri-facebook-box-line', label: 'Facebook' },
                ].map((social) => (
                  <a
                    key={social.label}
                    href="#"
                    className="w-10 h-10 flex items-center justify-center border border-brand-border rounded-lg text-gray-400 hover:border-neon-green hover:text-neon-green transition-all duration-200 cursor-pointer"
                    aria-label={social.label}
                  >
                    <i className={social.icon} />
                  </a>
                ))}
              </div>
            </div>
          </div>

          {/* Form */}
          <form
            data-readdy-form
            onSubmit={handleSubmit}
            className="bg-brand-card border border-brand-border rounded-xl p-8 space-y-5"
          >
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <label className="text-gray-400 text-xs mb-1.5 block">Nome *</label>
                <input
                  type="text"
                  name="name"
                  required
                  placeholder="Seu nome"
                  className="w-full bg-brand-bg border border-brand-border rounded-md px-4 py-3 text-white text-sm placeholder-gray-600 focus:outline-none focus:border-neon-green/60 transition-colors"
                />
              </div>
              <div>
                <label className="text-gray-400 text-xs mb-1.5 block">E-mail *</label>
                <input
                  type="email"
                  name="email"
                  required
                  placeholder="seu@email.com"
                  className="w-full bg-brand-bg border border-brand-border rounded-md px-4 py-3 text-white text-sm placeholder-gray-600 focus:outline-none focus:border-neon-green/60 transition-colors"
                />
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <label className="text-gray-400 text-xs mb-1.5 block">Telefone</label>
                <input
                  type="tel"
                  name="phone"
                  placeholder="(11) 99999-9999"
                  className="w-full bg-brand-bg border border-brand-border rounded-md px-4 py-3 text-white text-sm placeholder-gray-600 focus:outline-none focus:border-neon-green/60 transition-colors"
                />
              </div>
              <div>
                <label className="text-gray-400 text-xs mb-1.5 block">Empresa</label>
                <input
                  type="text"
                  name="company"
                  placeholder="Nome da empresa"
                  className="w-full bg-brand-bg border border-brand-border rounded-md px-4 py-3 text-white text-sm placeholder-gray-600 focus:outline-none focus:border-neon-green/60 transition-colors"
                />
              </div>
            </div>

            <div>
              <label className="text-gray-400 text-xs mb-1.5 block">Serviço de Interesse</label>
              <select
                name="service"
                className="w-full bg-brand-bg border border-brand-border rounded-md px-4 py-3 text-gray-300 text-sm focus:outline-none focus:border-neon-green/60 transition-colors cursor-pointer"
              >
                <option value="">Selecione um serviço</option>
                <option value="Redes e Wi-Fi Empresarial">Redes e Wi-Fi Empresarial</option>
                <option value="Microsoft 365 e E-mail">Microsoft 365 &amp; E-mail</option>
                <option value="Servidores e Backup">Servidores e Backup</option>
                <option value="Segurança e Monitoramento">Segurança e Monitoramento</option>
                <option value="Cabeamento Estruturado">Cabeamento Estruturado</option>
                <option value="Outro">Outro</option>
              </select>
            </div>

            <div>
              <label className="text-gray-400 text-xs mb-1.5 flex justify-between">
                <span>Mensagem *</span>
                <span className={charCount > 500 ? 'text-red-400' : 'text-gray-600'}>{charCount}/500</span>
              </label>
              <textarea
                name="message"
                required
                rows={4}
                placeholder="Descreva seu projeto ou necessidade..."
                onChange={(e) => setCharCount(e.target.value.length)}
                className="w-full bg-brand-bg border border-brand-border rounded-md px-4 py-3 text-white text-sm placeholder-gray-600 focus:outline-none focus:border-neon-green/60 transition-colors resize-none"
              />
              {charCount > 500 && (
                <p className="text-red-400 text-xs mt-1">Mensagem deve ter no máximo 500 caracteres.</p>
              )}
            </div>

            {status === 'success' && (
              <div className="flex items-center gap-2 bg-neon-green/10 border border-neon-green/30 rounded-md px-4 py-3">
                <i className="ri-checkbox-circle-fill text-neon-green" />
                <span className="text-neon-green text-sm">Mensagem enviada com sucesso! Entraremos em contato em breve.</span>
              </div>
            )}
            {status === 'error' && (
              <div className="flex items-center gap-2 bg-red-500/10 border border-red-500/30 rounded-md px-4 py-3">
                <i className="ri-error-warning-line text-red-400" />
                <span className="text-red-400 text-sm">Erro ao enviar. Tente novamente ou entre em contato pelo WhatsApp.</span>
              </div>
            )}

            <button
              type="submit"
              disabled={status === 'sending' || charCount > 500}
              className="w-full bg-neon-green text-black font-bold py-3.5 rounded-md hover:bg-green-400 transition-colors disabled:opacity-60 disabled:cursor-not-allowed cursor-pointer whitespace-nowrap text-sm"
            >
              {status === 'sending' ? 'Enviando...' : 'Enviar Mensagem'}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}
